import React, {memo, useEffect, useRef, useState} from "react";
import {Head} from "../../../components";
import Container from "@mui/material/Container";
import {Box, Paper} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import {toast} from "react-toastify";
import {connect} from "react-redux";
import Button from "@mui/material/Button";
import Api from "../../../utils/api";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Add from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import SunEditor, {buttonList} from "suneditor-react";


const TicketCategoryFAQ = memo((props) => {


    const { treeReducer } = props;


    const initStat = {}
    const editor = useRef();

    const [form, setForm] = useState(initStat);
    const [entity, setEntity] = useState(null);
    const [loading, setLoading] = useState(false);


    useEffect(() => {

        handleRequest();

    }, []);

    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };


    const handleRequest = () => {
        new Api().get('/tickets/categories/' + treeReducer.checked, false).then((response) => {
            if (typeof response !== "undefined") {
                setEntity(response);

                let n_faq = [{
                    key : '',
                    value: '',
                    sort: ''
                }];
                if (response.faq) {
                    n_faq = JSON.parse(response.faq);
                }

                setForm({
                    content: response.content,
                    faq: n_faq
                });
            }
        })
    }


    const handleSubmit = (event) => {
        event.preventDefault();

        setLoading(true);

        new Api().post('/tickets/categories/' + treeReducer.checked + '/document', form, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                    handleRequest();
                } else {
                    toast.error(response.msg);
                }
            }
            setLoading(false);
        })

    }


    // change state
    const handleDuplicateRaw = (event, i, key) => {
        let n_form = form;
        n_form[key][i][event.target.name] = event.target.value;
        setForm({...n_form});
    };

    const duplicateRaw = (state, key, id) => {
        let n_form = form;
        for (let i=0; i < n_form[state].length; i++) {
            if (n_form[state][i][key] === id) {
                let pusher;
                Object.keys(n_form[state][i]).forEach((key) => {
                    pusher = {
                        key: '',
                        value : '',
                        sort: ''
                    }
                });
                n_form[state].push(pusher)

                setForm({...n_form});

                break;
            }
        }
    }

    const deleteRaw = (state, key, id) => {
        if (form[state].length > 1) {
            let n_form = form;
            for (let i = 0 ; i < n_form[state].length ; i++) {
                if (n_form[state][i][key] === id) {
                    n_form[state].splice(i, 1)
                    setForm({...n_form});
                    break;
                }
            }
        } else {
            toast.error('امکان حذف ایتم وجود ندارد.');
        }

    }
    return(
        <Container>
            <Head data={{ 'link': '/ticket/category', 'title': `داکیومنت سازی و پرسش و پاسخ ` + (entity ? entity.title : '') }} />
            <Box mt={5}>
                <form onSubmit={handleSubmit}>
                    <Box mt={5} mb={5}>
                        <Paper style={{ padding: '25px'}}>
                        <div style={{ overflowX: 'auto'}}>
                            <table className='table-duplicate-row fadeIn'>
                                <thead>
                                <tr>
                                    <th width={50}>ردیف</th>
                                    <th>سوال</th>
                                    <th>پاسخ</th>
                                    <th width={50}>سورت</th>
                                    <th width={100}></th>
                                </tr>
                                </thead>
                                <tbody>
                                {form.faq && form.faq.length > 0 && form.faq.map((s, index) => {
                                    return(<tr key={index}>
                                        <td>{index + 1 }</td>
                                        <td><TextField inputProps={{ step: 1000}} variant={"outlined"} onChange={(event) => handleDuplicateRaw(event, index, 'faq')} name={'key'} fullWidth value={s.key} /></td>
                                        <td><TextField inputProps={{ step: 300}} variant={"outlined"} onChange={(event) => handleDuplicateRaw(event, index, 'faq')} name={'value'} fullWidth value={s.value} /></td>
                                        <td><TextField  variant={"outlined"} onChange={(event) => handleDuplicateRaw(event, index, 'faq')} name={'sort'} value={s.sort ? s.sort : index} /></td>
                                        <td>
                                            <Tooltip title={'ایجاد'}>
                                                <IconButton color='primary' onClick={() => duplicateRaw('faq', 'faq_id', s.faq_id)} >
                                                    <Add />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={'حذف'}>
                                                <IconButton color='secondary' onClick={() => deleteRaw('faq', 'faq_id', s.faq_id)}>
                                                    <RemoveCircleIcon  />
                                                </IconButton>
                                            </Tooltip>
                                        </td>
                                    </tr>);
                                })}
                                </tbody>
                            </table>
                        </div>
                        </Paper>
                    </Box>
                    <Box mt={5} mb={5}>
                        <Paper style={{ padding: '25px'}}>
                            <Grid item xs={12} style={{ margin: '20px 0'}}>
                                <SunEditor
                                    setOptions={{
                                        height: 200,
                                        buttonList: buttonList.complex
                                    }}
                                    height="800px"
                                    getSunEditorInstance={getSunEditorInstance}
                                    defaultValue={form.content && form.content}
                                    onChange={(value) => {
                                        let n_form = form;
                                        n_form['content'] = value;
                                        setForm({...n_form});
                                    }}/>
                            </Grid>
                        </Paper>
                    </Box>
                    <Box mt={5}>
                        <Button disabled={loading} variant='contained' color='primary' type="submit">ارسال اطلاعات</Button>
                    </Box>
                </form>
            </Box>
        </Container>
    );
})

const mapStateToProps = state => ({
    treeReducer: state.treeReducer
})

export default connect(mapStateToProps)(TicketCategoryFAQ);